module.exports = __webpack_public_path__ + "/images/embarazada-p-500.2190ea1.jpeg";